import CourtCard from "./CourtCard";

function CourtGrid({
    courts,
    selectedCourt,
    setSelectedCourt,
}) {

    const singleCard =
        courts.length === 1;

    return (

        <div
            style={{
                ...styles.grid,

                ...(singleCard
                    ? styles.singleGrid
                    : {}),
            }}
        >

            {courts.map((court) => (

                <CourtCard
                    key={court.id}
                    court={court}
                    selected={
                        selectedCourt?.id === court.id
                    }
                    onClick={() =>
                        setSelectedCourt(court)
                    }
                />
            ))}

        </div>
    );
}

const styles = {

    grid: {
        display: "grid",

        gridTemplateColumns:
            "repeat(auto-fit, minmax(320px, 380px))",

        gap: "28px",

        marginBottom: "40px",
    },

    /* SINGLE CARD CENTER */
    singleGrid: {
        justifyContent: "flex-start",
    },
};

export default CourtGrid;